// ===== Emissoras (as duas empresas do grupo) =====
//
// Mora aqui, e nao em src/data.jsx, porque o DOCUMENTO da proposta precisa
// destes dados e o documento roda tambem em Deno -- na Edge Function que serve a
// pagina publica que o cliente abre pelo link.
//
// Nao e dado de tela: e a IDENTIDADE FISCAL que sai impressa na proposta e no
// pedido. Razao social, CNPJ, inscricao estadual e endereco de faturamento. Duas
// copias disso acabariam divergindo, e a divergencia apareceria num documento
// que o cliente ja recebeu.
//
// `idEmpresa` e o que o Nomus chama de empresa emissora do pedido -- conferido
// na 0050 contra `emissoras.id_empresa_nomus` no banco.

export const EMISSORAS = [
  {
    id: "pdled",
    idEmpresa: 2,
    nome: "PDLED",
    grupo: "Família Sant'Anna",
    razaoSocial: "FAMÍLIA SANT'ANNA PDL COMÉRCIO, INDÚSTRIA, EXPORTAÇÃO E IMPORTAÇÃO LTDA",
    cnpj: "05.842.258/0001-59",
    ie: "77616934",
    site: "www.pdled.com.br",
    faturamento: "Av. das Américas, 28499 · Guaratiba · Rio de Janeiro · RJ · CEP 23020-420",
    cor: "#0E7C86",
    corDeep: "#0a5e66",
  },
  {
    id: "pdlight",
    idEmpresa: 3,
    nome: "PDLIGHT",
    grupo: "Família Tosto",
    razaoSocial: "FAMÍLIA TOSTO PDL COMÉRCIO, INDÚSTRIA, EXPORTAÇÃO E IMPORTAÇÃO LTDA",
    cnpj: "44.422.606/0001-90",
    ie: "12303920",
    site: "www.pdled.com.br",
    faturamento: "Av. das Américas, 28499 · Guaratiba · Rio de Janeiro · RJ · CEP 23020-420",
    cor: "#9C5A3C",
    corDeep: "#7a4530",
  },
];
export const EMISSORAS_BY_ID = Object.fromEntries(EMISSORAS.map(e => [e.id, e]));
